import { onMounted, onUnmounted, reactive } from "vue";
import type { IScrollInfo } from "~/shared/interfaces/composables";

export function  useWindowScroll(): IScrollInfo {
  const scrollInfo = reactive<IScrollInfo>({
    scrollTop: 0,
    isScrollDown: null,
  })

  let prevScrollState = 0;

  const scrollEventListener = () => {
    let currentScroll = document.documentElement.scrollTop;
    scrollInfo.scrollTop = currentScroll;
    if (currentScroll < prevScrollState) {
      scrollInfo.isScrollDown = false;
    } else {
      if (window.scrollY > 50) {
        scrollInfo.isScrollDown = true;
       }
    }

    prevScrollState = currentScroll;
  }

  onMounted(() => {
    window.addEventListener('scroll', scrollEventListener)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', scrollEventListener)
  })

  return scrollInfo;
}
